import { extractExcel } from "./excelextract"
import { extractImages } from "./extractimages"
import { extractDoc } from "./extractword"
import { extractPdf } from "./pdfextract"
import { chunkText, convertTextToMarkdown } from "./utils"

import { estimateTokenCount } from 'tokenx'


export const extractor = {
  extractPdf,
  extractDoc,
  extractExcel,
  chunkText,
  convertTextToMarkdown,
  extractImages,
  estimateTokenCount,
}


